import { render, staticRenderFns } from "./AutoCompleteUser.vue?vue&type=template&id=5971704a"
import script from "./AutoCompleteUser.vue?vue&type=script&lang=js"
export * from "./AutoCompleteUser.vue?vue&type=script&lang=js"
import style0 from "./AutoCompleteUser.vue?vue&type=style&index=0&id=5971704a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports